import http from '../../services/http-common';
import securityService from '../../components/security/security.service';


class TenantContractService {
  getPropertyDetailForList(id) {
    return http.get(`/TenantContract/PropertyDetailForList/${id}`);
  }
  getPaymentDetailForList(id, IsChequeCleared) {
    return http.get(`/TenantContract/PaymentDetailForList/${securityService.getCompanyIDLoggedInUserId()}/${id}/2`);
  }
  getAdditionalPaymentDetailForList(id) {
    return http.get(`/TenantContract/AdditionalPaymentDetailForList/${id}`);
  }
  getAmountForAddionalPaymentForPercent(val1, val2) {
    let queryParams = new URLSearchParams({ContractAmountAED:val1,Percent:val2}).toString();

    return http.get(`/TenantContract/GetAmountForAddionalPaymentForPercent?${queryParams}`);
  }
  getAgentCommissionAmount(val1, val2,val3) {
    let queryParams = new URLSearchParams({ChequeAmount:val1,AdditionalPaymentAmount:val2,AgentCommissionPercent:val3}).toString();

    return http.get(`/TenantContract/GetAgentCommissionAmount?${queryParams}`);
  }

  getTenantContractFSAmount(val1, val2,val3,val4) {
    let queryParams = new URLSearchParams({RentAmountAED:val1,DiscountAmountAED:val2,ContractStartDate:val3,ContractEndDate:val4}).toString();
    return http.get(`/TenantContract/GetTenantContractFSAmount?${queryParams}`);
  }


  updateTenantContractFSAdditionalPaymentPercentBasedCalculations(val1, val2) {
    let queryParams = new URLSearchParams({ContractAmountAED:val1,TenantContractFSID:val2}).toString();

    return http.get(`/TenantContract/updateTenantContractFSAdditionalPaymentPercentBasedCalculations?${queryParams}`);
  }
  getTotalTenantContractFSAmount(val1, val2,val3) {
    let queryParams = new URLSearchParams({ContractAmountAED:val1,DepositAmount:val2,GridSum:val3}).toString();

    return http.get(`/TenantContract/GetTotalTenantContractFSAmount?${queryParams}`);
  }
  spGetAddionalPayment() {
    return http.get(`/TenantContract/AddionalPayment`);
  }
  getTenantContractForList() {
    return http.get(`/TenantContract/db/table`);
  }




  insertPropertyDetailWithMain(data) {
    return http.post(`/TenantContract/db/PropertyDetailWithMain/add`, data);
  }
  insertPropertyDetail(data) {
    return http.post(`/TenantContract/db/PropertyDetail/add`, data);
  }
  
  insertPaymentDetail(data) {
    return http.post(`/TenantContract/db/PaymentDetail/add`, data);
  }
  insertPaymentDetailWithMain(data) {
    return http.post(`/TenantContract/db/PaymentDetailWithMain/add`, data);
  }
  insertAdditionalPaymentDetail(data) {
    return http.post(`/TenantContract/db/AdditionalPaymentDetail/add`, data);
  }
  insertAdditionalPaymentDetailWithMain(data) {
    return http.post(`/TenantContract/db/AdditionalPaymentDetailWithMain/add`, data);
  }
  
  insertAdditionalPaymentDetailSWithMain(data) {
    return http.post(`/TenantContract/db/AdditionalPaymentDetailsWithMain/add`, data);
  }
  
  
  updatePropertyDetail(data) {
    return http.put(`/TenantContract/db/PropertyDetail/edit`, data);
  }

  updatePaymentDetail(data) {
    return http.put(`/TenantContract/db/PaymentDetail/edit`, data);
  }
  updateAddtionalPaymentDetail(data) {
    return http.put(`/TenantContract/db/AdditionalPaymentDetail/edit`, data);
  }


  insert(data) {
    return http.post(`/TenantContract/db/add`, data);
  }
  update(data) {
    return http.put(`/TenantContract/db/edit`, data);
  }
  delete(PropertyID) {
    return http.delete(`/TenantContract/db/delete/${PropertyID}`);
  }
}

export default new TenantContractService();